import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function MetaTags({ channelData }) {
  const location = useLocation();
  // The one canonical tag for every route (pages don't add their own, or there'd be two)
  const pageURL = `${process.env.REACT_APP_ROOT_DOMAIN}${location.pathname}`;

  // Copy before sorting: channelData is the app's own list
  const sortedChannelData = [...channelData].sort((a, b) => a.order - b.order);
  const pageTitle = sortedChannelData.length > 0
    ? `Streams | ${sortedChannelData.map((channel) => channel.username).join(', ')}`
    : 'Multi Twitch, YouTube & Kick Live Streams | Watchstreams.tv';

  // og:*/twitter:* tags are constant across every route and are declared
  // statically in public/index.html instead — Helmet only ever appends new
  // link/meta nodes, it doesn't replace static ones, so duplicating them
  // here would leave two of each in the DOM after mount.
  return (
    <HelmetProvider>
      <Helmet>
        <title>{pageTitle}</title>
        <link rel="canonical" href={pageURL} />
      </Helmet>
    </HelmetProvider>
  );
}

export default MetaTags;
